/**
 * Multi-Product Selector Validation
 * Validates Product 1 & 2 variant options (Option 2, Option 3) and Product 2 line item properties
 * Runs on "Add Both to Cart" click - shows validation messages for unselected options
 * Independent of product.js - does not modify theme core
 */

(function() {
  'use strict';

  /**
   * Validate Product 1 & 2 variant options (Option 2 and Option 3 only)
   * Skips Option 1 (always selected) and options with only 1 choice (auto-selected)
   */
  function validateMultiProductVariants() {
    let allValid = true;
    let firstUnselected = null;

    const variantSelects = document.querySelectorAll('.multi-product-variant-selects');
    variantSelects.forEach(function(variantSelect) {
      const option2Fieldset = variantSelect.querySelector('fieldset[data-index="option2"]');
      const option3Fieldset = variantSelect.querySelector('fieldset[data-index="option3"]');

      [option2Fieldset, option3Fieldset].forEach(function(fieldset) {
        if (!fieldset) return;

        const select = fieldset.querySelector('select');
        const radios = fieldset.querySelectorAll('input[type="radio"]');
        let optionCount = 0;

        if (select) {
          optionCount = Array.from(select.options).filter(function(opt) {
            return opt.value && opt.value.trim() !== '';
          }).length;
        } else if (radios.length > 0) {
          optionCount = radios.length;
        }

        if (optionCount <= 1) return;

        let isSelected = false;
        if (select) {
          isSelected = select.value && select.value.trim() !== '';
        } else if (radios.length > 0) {
          isSelected = Array.from(radios).some(function(r) { return r.checked; });
        }

        const label = fieldset.querySelector('.form__label');
        if (!label) return;

        if (!isSelected) {
          allValid = false;
          if (!firstUnselected) firstUnselected = fieldset;

          label.classList.add('label-text-hidden');
          var existingMsg = label.querySelector('.variant-validation-message');
          if (existingMsg) existingMsg.remove();
          var msg = document.createElement('span');
          msg.className = 'variant-validation-message';
          msg.textContent = 'Please select ' + (label.textContent.split(':')[0].trim() || 'this option');
          label.appendChild(msg);
        } else {
          label.classList.remove('label-text-hidden');
          var msgToRemove = label.querySelector('.variant-validation-message');
          if (msgToRemove) msgToRemove.remove();
        }
      });
    });

    return { isValid: allValid, firstUnselected: firstUnselected };
  }

  /**
   * Validate Product 2 line item properties (Rise, Length, Fit Type)
   * Skips if fieldset has only 1 choice (auto-selected)
   */
  function validateMultiProductLineItemProperties() {
    const propertyFieldsets = [
      { selector: 'fieldset[data-handle="fit-type"]', name: 'properties[Fit Type]', label: 'Fit Type' },
      { selector: 'fieldset[data-handle="rise"]', name: 'properties[Rise]', label: 'Rise' },
      { selector: 'fieldset[data-handle="length"]', name: 'properties[Length]', label: 'Length' }
    ];

    let allValid = true;
    let firstUnselected = null;

    propertyFieldsets.forEach(function(prop) {
      const fieldset = document.querySelector(prop.selector);
      if (!fieldset) return;

      const inputs = fieldset.querySelectorAll('input[name="' + prop.name + '"]');
      if (inputs.length <= 1) return;

      const checkedInput = fieldset.querySelector('input[name="' + prop.name + '"]:checked');
      const label = fieldset.querySelector('.form__label');
      if (!label) return;

      if (!checkedInput) {
        allValid = false;
        if (!firstUnselected) firstUnselected = fieldset;

        label.classList.add('label-text-hidden');
        var existingMsg = label.querySelector('.variant-validation-message');
        if (existingMsg) existingMsg.remove();
        var msg = document.createElement('span');
        msg.className = 'variant-validation-message';
        msg.textContent = 'Please select ' + prop.label;
        label.appendChild(msg);
      } else {
        label.classList.remove('label-text-hidden');
        var msgToRemove = label.querySelector('.variant-validation-message');
        if (msgToRemove) msgToRemove.remove();
      }
    });

    return { isValid: allValid, firstUnselected: firstUnselected };
  }

  /**
   * Update form__label__value with selected option value (e.g. Size: XXS)
   */
  function updateVariantLabelValue(fieldset, input) {
    if (!fieldset || !input) return;
    var valueSpan = fieldset.querySelector('.form__label__value');
    if (!valueSpan) return;
    var value = '';
    if (input.tagName === 'SELECT') {
      value = input.value && input.value.trim() !== '' ? input.value : '';
    } else if (input.checked) {
      value = input.value || '';
    }
    valueSpan.textContent = value;
  }

  /**
   * Clear validation styling from a fieldset
   */
  function clearMultiProductValidation(fieldset) {
    if (!fieldset) return;
    const label = fieldset.querySelector('.form__label');
    if (label) {
      label.classList.remove('label-text-hidden');
      const msg = label.querySelector('.variant-validation-message');
      if (msg) msg.remove();
    }
  }

  /**
   * Run all validations - returns false if any validation fails
   */
  function validateMultiProductForm() {
    const variantResult = validateMultiProductVariants();
    const lineItemResult = validateMultiProductLineItemProperties();

    return {
      isValid: variantResult.isValid && lineItemResult.isValid,
      firstUnselected: variantResult.firstUnselected || lineItemResult.firstUnselected
    };
  }

  window.MultiProductValidation = {
    validate: validateMultiProductForm,
    clearFieldset: clearMultiProductValidation,
    validateVariants: validateMultiProductVariants,
    validateLineItemProperties: validateMultiProductLineItemProperties
  };

  document.addEventListener('DOMContentLoaded', function() {
    if (!document.querySelector('.multi-product-variant-selects')) return;

    document.querySelectorAll('.multi-product-variant-selects').forEach(function(vs) {
      vs.addEventListener('change', function(e) {
        const fieldset = e.target.closest('fieldset');
        if (fieldset) {
          clearMultiProductValidation(fieldset);
          updateVariantLabelValue(fieldset, e.target);
        }
      }, true);
    });

    ['properties[Fit Type]', 'properties[Rise]', 'properties[Length]'].forEach(function(name) {
      document.querySelectorAll('input[name="' + name + '"]').forEach(function(input) {
        input.addEventListener('change', function() {
          const fieldset = this.closest('fieldset');
          if (fieldset) clearMultiProductValidation(fieldset);
        });
      });
    });
  });
})();
